import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { NOT_FOUND_STATUS_CODE } from 'utils/status';

const { getAudienceData } = API.END_POINTS.API;

const RECEIVE = 'influencerAudienceData/RECEIVE';
const CLEAN = 'influencerAudienceData/CLEAN';
const GATHERING_DATA = 'influencerAudienceData/GATHERING_DATA';

const initialState = {
  data: {
    audienceGenderSplit: [],
    audienceAgeSplit: [],
    audienceTopCountries: [],
    audienceTopCities: [],
    audienceTopInterests: [],
    audienceReachabilityDistribution: [],
    audienceReachabilityScore: null,
    audienceCredibility: null
  },
  isLoading: true,
  isGatheringData: false
};

function getReachabilityScore(audienceReachability) {
  const reachabilityPercent = audienceReachability.find(item => item.label === '1500-');
  let reachabilityScore = 'excellent';

  if (!reachabilityPercent) {
    return reachabilityScore;
  }

  if (reachabilityPercent.percentage > 60) {
    reachabilityScore = 'acceptable';
  } else if (reachabilityPercent.percentage > 46) {
    reachabilityScore = 'good';
  } else if (reachabilityPercent.percentage > 30) {
    reachabilityScore = 'very_good';
  }

  return reachabilityScore;
}

function receiveInfluencerAudience(data) {
  return {
    type: RECEIVE,
    payload: {
      data: {
        audienceGenderSplit: data.audienceGenderSplit,
        audienceAgeSplit: data.audienceAgeSplit,
        audienceTopCountries: data.audienceTopCountries,
        audienceTopCities: data.audienceTopCities,
        audienceTopInterests: data.audienceTopInterests,
        audienceReachabilityDistribution: data.audienceReachabilityDistribution || [],
        audienceReachabilityScore: data.audienceReachabilityDistribution && getReachabilityScore(data.audienceReachabilityDistribution || []),
        audienceCredibility: data.audienceCredibility
      }
    }
  };
}

function receiveGatheringData() {
  return {
    type: GATHERING_DATA
  };
}

export function cleanInfluencerAudienceData() {
  return (dispatch) => {
    dispatch({
      type: CLEAN
    });
  };
}

export function fetchAudienceData(channelUserName, channelType) {
  return (dispatch) => {
    // clean the data specially when we switch between profiles without unmounting the component
    dispatch(cleanInfluencerAudienceData());

    const url = getAudienceData(channelUserName, channelType);

    return get(url, {}, { suppressGlobalNotification: true })
      .then(response => dispatch(receiveInfluencerAudience(response.data)))
      .catch((error) => {
        // always show gathering data
        if (error.response) {
          dispatch(receiveGatheringData());
        }

        if (error.response && error.response.status !== NOT_FOUND_STATUS_CODE) {
          logError(error);
        }
      });
  };
}

export default createReducer('influencerAudienceData', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [CLEAN]: () => initialState,
  [GATHERING_DATA]: (state) => ({
    ...state,
    isGatheringData: true
  }),
  [RECEIVE]: (state, { data }) => ({
    ...state,
    data,
    isLoading: false
  })
});
